import React, {useEffect} from "react";
import useAgeType from "../Stores/AgeStore";
interface AgeProps {
  displayValue: number;
  id?: string;
}
const AgeMenu: React.FC<AgeProps> = ({displayValue, id}): JSX.Element => {
  const ageValue = useAgeType((state) => state.ageValue);
  const setAgeValue = useAgeType((state) => state.setAgeValue);
  const disabledAge = useAgeType((state) => state.disabledAge);
  const ageList = useAgeType((state) => state.ageList);

  useEffect(() => {}, [displayValue]);

  return (
    <select
      id={id}
      className={`text-center lg:text-center pl-1 pr-4 xl:select xl:select-bordered text-[12px] bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent ${
        disabledAge ? "text-gray-400 opacity-60 cursor-not-allowed" : ""
      }`}
      defaultValue={ageValue}
      onChange={(event) => setAgeValue(Number(event.target.value))}
      disabled={disabledAge}>
      {ageList.map((label, index) => (
        <option key={index} value={index}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default AgeMenu;
